// Password pages normally contain only signup and editorial blocks. Keep the
// commerce modules inert until a product/cart block actually needs them.
const assets = document.querySelector('template[data-password-commerce-assets]');
const commerceSelector = [
  'product-card', 'product-card-link', 'product-form-component', 'add-to-cart-component',
  'variant-picker', 'swatches-variant-picker-component', 'quick-add-component', 'quick-add-dialog',
  'product-price', 'product-sku-component', 'product-title', 'product-inventory', 'product-hotspot-component',
  'quantity-selector-component', 'cart-quantity-selector-component', 'cart-items-component',
  'cart-discount-component', 'volume-pricing', 'price-per-item', 'volume-pricing-info',
  'para-complete-look', 'para-cart-rewards',
].join(',');

if (assets) {
  let loaded = false;
  const activate = () => {
    if (loaded) return;
    loaded = true;
    observer.disconnect();
    for (const resource of assets.content.querySelectorAll('link, script[src]')) {
      // Fresh script nodes execute; scripts copied out of inert template content
      // are not relied upon to execute consistently across browsers.
      const node = document.createElement(resource.localName);
      for (const attribute of resource.attributes) node.setAttribute(attribute.name, attribute.value);
      document.head.append(node);
    }
    assets.remove();
  };
  const containsCommerce = (node) => node instanceof Element
    && (node.matches(commerceSelector) || node.querySelector(commerceSelector));
  const observer = new MutationObserver((records) => {
    if (records.some((record) => [...record.addedNodes].some(containsCommerce))) activate();
  });
  if (document.querySelector(commerceSelector)) activate();
  else observer.observe(document.body, { childList: true, subtree: true });
}
